import { TRANSITION_M } from "../config/constants";
import type { ZoneId, ZoneLeg } from "../config/types";

export interface ZoneInfo {
    zone: ZoneId;
    next: ZoneId | null;
    zoneProgress: number;
    intoM: number;
    blend: number;
    courseProgress: number;
}

const clamp = (n: number, min: number, max: number) => Math.min(max, Math.max(min, n));
const mod = (n: number, m: number) => ((n % m) + m) % m;

export function courseLength(legs: ZoneLeg[]): number {
    return legs.reduce((total, leg) => total + leg.lengthM, 0);
}

export function zoneAt(distanceM: number, legs: ZoneLeg[], endless: boolean): ZoneInfo {
    const total = courseLength(legs);
    const d = endless ? mod(distanceM, total) : clamp(distanceM, 0, total);

    let start = 0;
    let index = 0;
    while (index < legs.length - 1 && d >= start + legs[index].lengthM) {
        start += legs[index].lengthM;
        index++;
    }

    const leg = legs[index];
    const end = start + leg.lengthM;
    const next = index + 1 < legs.length ? legs[index + 1].zone : endless ? legs[0].zone : null;

    return {
        zone: leg.zone,
        next,
        zoneProgress: clamp((d - start) / leg.lengthM, 0, 1),
        intoM: d - start,
        blend: next ? clamp((d - (end - TRANSITION_M)) / TRANSITION_M, 0, 1) : 0,
        courseProgress: endless ? 0 : d / total,
    };
}
